import { render, staticRenderFns } from "./FPSReport2.vue?vue&type=template&id=2bff1f99&scoped=true"
import script from "./FPSReport2.vue?vue&type=script&lang=js"
export * from "./FPSReport2.vue?vue&type=script&lang=js"
import style0 from "./FPSReport2.vue?vue&type=style&index=0&id=2bff1f99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff1f99",
  null
  
)

export default component.exports